export default __webpack_public_path__ + "static/media/profileSample.b6d9ae65.png";